import { render, staticRenderFns } from "./ProductImageLink.vue?vue&type=template&id=88a779de"
import script from "./ProductImageLink.vue?vue&type=script&lang=js"
export * from "./ProductImageLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports